// Tells the preload loader that a Solid template is shown, so it refreshes
// the client file's data. The template's request context names the client
// file, the period and the reconciliation text.
export const refreshSolidData = (context: Record<string, unknown>): void => {
  const { firmId, companyId, ledgerId, reconciliationTextId } = context as {
    firmId?: string | number
    companyId?: string | number
    ledgerId?: string | number
    reconciliationTextId?: string | number
  }
  if (!firmId || !companyId) return

  void window.silverfinSolidData?.loadData(
    firmId,
    companyId,
    ledgerId,
    reconciliationTextId
  )
}
